import { ReactNode } from 'react';
import { Box, Text } from '@mantine/core';

type Props = {
  children: ReactNode;
  title?: string;
};

export const SidebarUpper = ({ children, title }: Props) => {
  return (
    <Box
      sx={theme => ({
        padding: theme.other.spacing(2, 3),
        background: theme.white,
      })}
    >
      {title && (
        <Box sx={theme => ({ marginBottom: theme.other.spacing(2) })}>
          <Text>{title}</Text>
        </Box>
      )}
      {children}
    </Box>
  );
};
